export { default } from './ClickAwayListener';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ClickAwayListener/index.js
// module id = 321
// module chunks = 0